import { memo } from "react";
import { func, shape, string, number, bool } from "prop-types";
import IconClose from "../../../../../Icon/IconClose";
import { FormattedAirDate } from "../../../../../VideoUtils/components/FormattedDate/component";

export const PersistentVideoUI = ({ onCloseClick, mediaItem }) => {
    const { title, showName, contentArea, sport, pubDate, isLive } = mediaItem;

    return (
        <div className="persistent-player-video-ui">
            <div>
                <button
                    onClick={onCloseClick}
                    className="close-persistent-player-button"
                    aria-label="Close player"
                >
                    <IconClose />
                </button>
            </div>
            <div id="persistent-player-media-metadata-video">
                {title && <h3 className="media-title">{title}</h3>}
                <div className="showname-and-timestamp">
                    <p className="media-showname">
                        {showName || contentArea || sport}
                    </p>
                    <FormattedAirDate
                        classes="media-timestamp"
                        airDate={pubDate}
                        isLive={isLive}
                    />
                </div>
            </div>
        </div>
    );
};

const isEqual = (prevProps, nextProps) => {
    return prevProps.mediaItem.sourceId === nextProps.mediaItem.sourceId;
};

export default memo(PersistentVideoUI, isEqual);

PersistentVideoUI.propTypes = {
    onCloseClick: func,
    mediaItem: shape({
        title: string,
        showName: string,
        contentArea: string,
        sport: string,
        pubDate: number,
        isLive: bool,
    }),
};
